"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _PageContainerShapeStyles.PageContainerShape;
  }
});

var _PageContainerShapeStyles = require("./PageContainerShape-styles");